import { AdminPagePanelProps } from './admin-page-panel-props';
import loadable from '@loadable/component';

export const AsyncAdminPagePanel = loadable<AdminPagePanelProps>((): any =>
  import('./admin-page-panel'),
);
